import MainLayout from 'src/layouts';
import Contributions from 'src/features/Contributions';
import { Helmet } from 'react-helmet';

const ContributePage = () => {
  return (
    <MainLayout>
      <Helmet>
        <title>My Contributions</title>
      </Helmet>
      <Contributions />
    </MainLayout>
  );
};

export default ContributePage;
